/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import cx from 'classnames';
import PropTypes from 'prop-types';
import React__default from 'react';
import SideNavIcon from './SideNavIcon.js';
import { usePrefix } from '../../internal/usePrefix.js';

const SideNavHeader = _ref => {
  let {
    children,
    className: customClassName,
    renderIcon: IconElement
  } = _ref;
  const prefix = usePrefix();
  const className = cx(`${prefix}--side-nav__header`, customClassName);
  return /*#__PURE__*/React__default.createElement("header", {
    className: className
  }, /*#__PURE__*/React__default.createElement(SideNavIcon, null, /*#__PURE__*/React__default.createElement(IconElement, null)), children);
};
SideNavHeader.displayName = 'SideNavHeader';
SideNavHeader.propTypes = {
  /**
   * The child nodes to be rendered
   */
  children: PropTypes.node,
  /**
   * Provide an optional class to be applied to the containing node
   */
  className: PropTypes.string,
  /**
   * Property to indicate if the side nav container is open (or not). Use to
   * keep local state and styling in step with the SideNav expansion state.
   */
  isSideNavExpanded: PropTypes.bool,
  /**
   * Provide an icon to render in the header of the side navigation. Should be
   * a React class.
   */
  // @ts-expect-error - PropTypes are unable to cover this case.
  renderIcon: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired
};

export { SideNavHeader as default };
